const E_PORTAL_BASE_URL = (process.env.REACT_APP_E_PORTAL_URL || '').replace(/\/$/, '');
const E_PORTAL_API_BASE_URL = (
  process.env.REACT_APP_E_PORTAL_API_URL ||
  `${E_PORTAL_BASE_URL}/api`
).replace(/\/$/, '');

export async function loginToEPortal(credentials) {
  const response = await fetch(`${E_PORTAL_API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...credentials,
      portal: 'staff',
    }),
  });

  return readPortalResponse(response, 'Unable to login right now.');
}

export async function fetchEPortalBusinesses(token) {
  const response = await fetch(`${E_PORTAL_API_BASE_URL}/businesses`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return readPortalResponse(response, 'Unable to load your Seaweed business.');
}

export function findSeaweedBusiness(businesses, user) {
  const launchableBusinesses = businesses.filter((business) => {
    const systemType = String(business?.system_type || '').trim().toLowerCase();
    const portalAccess = business?.portal_access ?? business?.portal_state ?? 'open';

    return systemType === 'seaweed' && business?.status === 'active' && portalAccess === 'open';
  });

  const primaryBusinessId = Number(user?.customer_id);

  return (
    launchableBusinesses.find((business) => Number(business.id) === primaryBusinessId) ||
    launchableBusinesses[0] ||
    null
  );
}

async function readPortalResponse(response, fallbackMessage) {
  const payload = await safeReadJson(response);

  if (!response.ok) {
    throw new Error(payload?.message || fallbackMessage);
  }

  return payload;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
